import {
  PrimaryText,
  SecondaryText,
} from '../../../CustomList/CustomList.styles';
import {
  EmployeeInfoContainer,
  ShiftsContainer,
  StatusContainer,
  ListEntryContainer
} from './PeopleListEntry.styles';
import { StyledAvatar } from '../../../StyledAvatar/StyledAvatar';
import EmployeeStatus from '../EmployeeStatus/EmployeeStatus';

const PeopleListEntry = ({ employee, futureShiftCount, isLast, statusData }) => {
  return (
    <ListEntryContainer isLast={isLast}>
      {/* Left: Employee Info */}
      <EmployeeInfoContainer>
        <StyledAvatar size="small" alt={employee.displayName || 'User'} src={employee.profileImageUrl} />
        <PrimaryText variant="bodyRegular">
          {employee.displayName}
        </PrimaryText>
      </EmployeeInfoContainer>

      {/* Middle: Shifts */}
      <ShiftsContainer>
        <SecondaryText variant="footNoteRegular">
          {futureShiftCount === 0 ? 'No' : futureShiftCount} shift{futureShiftCount === 1 ? '' : 's'} scheduled
        </SecondaryText>
      </ShiftsContainer>

      {/* Right: Status */}
      <StatusContainer>
        {statusData ? (
          <EmployeeStatus
            status={statusData.status}
            primaryStatus={statusData.primaryStatus}
            statusMessage={statusData.statusMessage}
            breakStatus={statusData.breakStatus}
            clockStatus={statusData.clockStatus}
            shiftInfo={statusData.shiftInfo}
          />
        ) : (
          <EmployeeStatus
            status="clocked-out"
            primaryStatus="clocked-out"
            statusMessage="Status loading..."
            clockStatus="out"
          />
        )}
      </StatusContainer>
    </ListEntryContainer>
  );
};

export default PeopleListEntry;
